import type { ResponseConfig } from "@kubb/swagger-client/client"
import { notifications } from "@mantine/notifications"
import { UseMutationOptions } from "@tanstack/react-query"
import { AxiosError } from "axios"

import { queryClient } from "~/backend/queryClient"
import {
  findMappingByTypeQueryKey,
  findPendingMappingQueryKey,
  useCreateMappingElement,
} from "~/gen/api/hooks"
import { CreateMappingElementRequestDto } from "~/gen/api/types"

export const useCreateMappingElementMutation = (
  options?: UseMutationOptions<
    ResponseConfig<boolean>,
    unknown,
    CreateMappingElementRequestDto
  >
) =>
  useCreateMappingElement({
    mutation: {
      ...options,
      onSuccess: async (_, variables) => {
        await queryClient.invalidateQueries(
          findMappingByTypeQueryKey(variables.type)
        )
        await queryClient.invalidateQueries(findPendingMappingQueryKey())
        notifications.show({
          title: "Created",
          message: ` mapping has been created`,
          color: "green",
        })
      },
      onError: (error) => {
        if (error instanceof AxiosError) {
          notifications.show({
            title: "Error",
            message: "Something went wrong, error : " + error.response?.data,
            color: "red",
          })
        }
      },
    },
  })
